// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1VPmk","label":"LabeledBox_label__3TOCE"};